import { Topic } from "../models";
import { BLUE, GREY, RED } from "./colors";
import * as React from "react";

export const getDeletionProps = (title: string, message: string, deleteMany: boolean) => {
    return {
        title,
        text: (
            <div>
                <div>
                    {`You're about to permanently delete `}
                    <b>{message}</b>
                    {`. You cannot undo this action.`}
                </div>
                <br />
                <div>Do you want to continue?</div>
            </div>
        ),
        yesColor: RED,
        noColor: GREY,
        yesText: deleteMany ? "Delete All" : "Delete",
        noText: "Cancel"
    };
};

const topicsInUse = (topics: Topic[]): JSX.Element => {
    return (
        <React.Fragment>
            {topics.map((topic) => {
                return (
                    <li key={topic.id}>
                        <span> {topic.name} </span>
                    </li>
                );
            })}
        </React.Fragment>
    );
};

const postsLink = (topics: string) => {
    const tenant = new URLSearchParams(window.location.search).get("tenant");
    return <a href={`/${tenant}/admin/posts?topics=${topics}&tabNum=3`} target="_blank" rel="noopener noreferrer">posts</a>;
};

const eventsLink = (topics: string) => {
    const tenant = new URLSearchParams(window.location.search).get("tenant");
    return <a href={`/${tenant}/admin/events?topics=${topics}&tabNum=3`} target="_blank" rel="noopener noreferrer">events</a>;
};

export const getInUseProps = (topics: Topic[], includesGroups: boolean) => {
    const toDelete = includesGroups ? "selected topic groups and topics" : "all selected topics";
    const text = topics.length > 1 ?
        `The following ${topics.length} topics are in use. This prevents ${toDelete} from being deleted.`
        : "The following topic is in use. Topics in use cannot be deleted.";
    const toRemove = topics.length > 1 ? "these topics" : "this topic";
    const where = topics.length > 1 ? "they are" : "it is";

    const topicsOnParam = topics.map(t => t.id).join(",");

    return {
        title: "Topics in Use",
        text: (
            <div>
                <div>
                    {text}
                </div>
                <ul>
                    {topicsInUse(topics)}
                </ul>
                <div>
                    Remove {toRemove} from the {postsLink(topicsOnParam)} or {eventsLink(topicsOnParam)} {where} used in to proceed
                </div>
            </div>
        ),
        yesText: "Ok",
        yesColor: BLUE,
        hideNo: true
    };
};
